import $ from 'jquery';

export default function appBannerModule() {
  const appBannerElement = $('.install-banner');
  if (appBannerElement.length) {
    return import(/* webpackChunkName: "app-banner" */ '../appBanner')
      .then(({ default: AppBanner }) => {
        const appBanner = new AppBanner();
        return appBanner;
      })
      .catch(() => 'An error occurred while loading the component');
  }
  return null;
}
